export const handleErrorResponse = async (response: Response) => {
  const result: any = await response.json();
  let errorMessage: string;
  if (result.errors) {
    errorMessage = result.errors.reduce(
      (previousValue: string, currentValue: string) =>
        previousValue + " " + currentValue,
      ""
    );
  } else {
    errorMessage = response.statusText;
  }
  throw new Error(errorMessage);
};
